import { BetterIdResult, Scan } from 'common/types'
import dayjs from 'lib/dayjs'

export interface isDatePastProps {
  date: BetterIdResult['expirationDate'] | Scan['expirationDate'] | Date
}

export const isDatePast = ({ date }: isDatePastProps) => {
  const isValidDate =
    typeof date === 'string' && new Date(date).toString() !== 'Invalid Date'

  const formattedDate = isValidDate ? dayjs(date).format('M/D/YYYY') : date

  const expiredDate = isValidDate && new Date(date) < new Date() ? date : null
  const isExpired = Boolean(expiredDate)

  return {
    isDateExpired: isExpired,
    expDate: formattedDate,
  }
}
